
import { SubDomain } from "../SubDomain.js";
import Registration from "./Registration.js";
import RegistrationMap from "./RegistrationMap.js";

export default class RegistrationDomain extends SubDomain {
  
  constructor(domain, storeMap) {
    super(domain, Registration.MODEL_NAME);
    this.storage = storeMap.RegistrationStorage;
  }

  list() {
    return this.storage.list;
  }
  
  findAll() {
    var objects = this.list();
    var Registrations = new RegistrationMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var Registration = new Registration(this.domain, item);
      Registrations.add(Registration);
    }

    return Registrations;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Registration(this.domain, item);
      }
    }

    return new Registration(this.domain);
  }
  
}